import React from 'react';

import ChoiceButtonContents from './ChoiceButtonContents';
import { useAnimationStageContext } from './AnimationStageContext';

const AnimationCursorChoiceButton = () => {
  const { stageKey, getSelectedAnimationCursorChoice } = useAnimationStageContext();

  if (!stageKey) {
    return null;
  }

  const { label, icon } = getSelectedAnimationCursorChoice();

  return (
    <ChoiceButtonContents label={label} id={`${stageKey}-cursor-choice-contents`}>
      {icon}
    </ChoiceButtonContents>
  );
};

export default AnimationCursorChoiceButton;
